import { useNavigate } from 'react-router-dom';
import AdsApi from '../api/ads';
import {
  AdAccountFilter, CampaignFilter, DEFAULT_SITE, SiteFilter, StatusFilter, listUrl,
} from '../components/ads/AdFilters';
import { Budget, METRIC_COLUMNS, NameCell, StatusChip } from '../components/ads/cells';
import ListPage from '../components/table/ListPage';
import { formatNumber, humanize } from '../utils/format';

const DEFAULTS = { site: DEFAULT_SITE, ordering: '-spend' };

const COLUMNS = [
  { id: 'name', label: 'Ad set', render: (row) => <NameCell name={row.name} secondary={row.campaign_name} /> },
  { id: 'effective_status', label: 'Status', render: (row) => <StatusChip row={row} /> },
  // targeting locales as Facebook names them; — when Facebook returns none
  { id: 'language', label: 'Language' },
  { id: 'optimization_goal', label: 'Optimization', sort: false, render: (row) => humanize(row.optimization_goal) },
  { id: 'budget', label: 'Budget', sort: 'daily_budget', render: (row) => <Budget row={row} /> },
  { id: 'ad_count', label: 'Ads', align: 'right', sort: false, render: (row) => formatNumber(row.ad_count) },
  ...METRIC_COLUMNS,
];

export default function AdSets() {
  const navigate = useNavigate();
  return (
    <ListPage
      title="Ad sets" description="Targeting, budget and delivery of each ad set. Open one to see its ads."
      fetchList={AdsApi.adsets} defaults={DEFAULTS} columns={COLUMNS} minWidth={1200}
      onRowClick={(row, query) => navigate(listUrl('/ads', query, { ad_account: row.ad_account_id,
        campaign: row.campaign_id, adset: row.id }))}
      emptyTitle="No ad sets yet" emptyHint="Enable an ad account and run a sync to see its ad sets."
      searchPlaceholder="Search name, id or language"
      filters={({ query, setQuery }) => (
        <>
          <SiteFilter query={query} setQuery={setQuery} />
          <StatusFilter query={query} setQuery={setQuery} />
          <AdAccountFilter query={query} setQuery={setQuery} />
          <CampaignFilter query={query} setQuery={setQuery} />
        </>
      )}
    />
  );
}
